<div style="
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    align-items: center;
  ">
  <div class="row" style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper search-wrapper">
      <div class="mcd-search-header">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          placeholder="Type to Search..."
          class="search-input-field"
          value="{{ searchKeyFromParent }}"
          (keyup.enter)="onSearch(key)"
          (input)="(0)"
          (keyup)="(0)"
          #key
        />
        <button
          type="button"
          class="clear-button"
          *ngIf="key.value || searchKeyFromParent"
          (click)="key.value = ''; onSearch(key)"
        >
          <mat-icon class="clear-icon">close</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <!-- Equipment dropdowen -->
  <div style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header">
        <div class="dropdown-trigger-btn" role="button" tabindex="0" (click)="toggleDropdown('equipment')" [style]="
            isequipmentTypesDropdownOpen ||
            getSelectedItemsCount('equipmentType').length > 0
              ? 'border: 1px solid #6574C4; background: #F8F9FF;'
              : 'border: 1px solid #DDE1E6;'
          ">
          <span class="trigger-label">Equipment Type</span>
          <span class="selected-count-badge" *ngIf="getSelectedItemsCount('equipmentType').length > 0">
            {{ getDisplayText("equipmentType") }}
          </span>
          <button type="button" class="remove-button" *ngIf="showFilterClearButton('equipmentType')"
            (click)="removeSelected('equipmentType', $event)" aria-label="Clear equipment type filter">
            <img src="/assets/images/s-remove 1.svg" alt="" />
          </button>
          <span class="trigger-chevron"><img src="/assets/images/down-arrow 1.svg" height="16px" width="16px"
              [style.transform]="isequipmentTypesDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'"
              [style.transition]="'transform 0.3s ease'" /></span>
        </div>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isequipmentTypesDropdownOpen">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>
          <input type="text" placeholder="Search" [(ngModel)]="equipmentTypesSearchText"
            (input)="filterEquipmentTypes()" class="search-input" />
        </div>

        <div class="mcd-dropdown-options">
          <ng-container *ngFor="let item of filteredequipmentTypes; let i = index">
            <div class="dropdown-option-item">
              <mat-checkbox [checked]="setCheckedStateForCheckBoxes(4, item.id)" (change)="
                  addFilter($event, item.id, 4, item.name, 'equipmentType')
                " (click)="$event.stopPropagation()">
                {{ item.name }}
              </mat-checkbox>
            </div>
            <div class="filter-selected-divider" *ngIf="showFilterDivider(filteredequipmentTypes, i, 4)"></div>
          </ng-container>
          <div class="no-results" *ngIf="filteredequipmentTypes.length === 0">
            No equipment types found
          </div>
        </div>

        <div class="mcd-dropdown-actions">
          <button mat-button class="apply-btn" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Location Dropdown -->
  <div style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header">
        <div class="dropdown-trigger-btn" role="button" tabindex="0" (click)="toggleDropdown('location')" [style]="
            isLocationDropdownOpen ||
            getSelectedItemsCount('location').length > 0
              ? 'border: 1px solid #6574C4; background: #F8F9FF;'
              : 'border: 1px solid #DDE1E6;'
          ">
          <span class="trigger-label">Location</span>
          <span class="selected-count-badge" *ngIf="getSelectedItemsCount('location').length > 0">
            {{ getDisplayText("location") }}
          </span>
          <button type="button" class="remove-button" *ngIf="showFilterClearButton('location')"
            (click)="removeSelected('location', $event)" aria-label="Clear location filter">
            <img src="/assets/images/s-remove 1.svg" alt="" />
          </button>
          <span class="trigger-chevron"><img src="/assets/images/down-arrow 1.svg" height="16px" width="16px"
              [style.transform]="isLocationDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'"
              [style.transition]="'transform 0.3s ease'" /></span>
        </div>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isLocationDropdownOpen">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>
          <input type="text" placeholder="Search" [(ngModel)]="locationSearchText" (input)="filterLocations()"
            class="search-input" />
        </div>

        <div class="mcd-dropdown-options">
          <ng-container *ngFor="let item of filteredLocations; let i = index">
            <div class="dropdown-option-item">
              <mat-checkbox [checked]="setCheckedStateForCheckBoxes(1, item.id)"
                (change)="addFilter($event, item.id, 1, item.name, 'location')" (click)="$event.stopPropagation()">
                {{ item.name }}
              </mat-checkbox>
            </div>
            <div class="filter-selected-divider" *ngIf="showFilterDivider(filteredLocations, i, 1)"></div>
          </ng-container>
          <div class="no-results" *ngIf="filteredLocations.length === 0">
            No locations found
          </div>
        </div>

        <div class="mcd-dropdown-actions">
          <button mat-button class="apply-btn" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Sub Location Dropdown (Conditional) -->
  <!-- <div style="display: inline-block" *ngIf="subLcationTypes && subLcationTypes.length > 0">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header" (click)="toggleSubLocationDropdown()">
        <button
          mat-button
          class="dropdown-trigger-btn"
          [style]="
            isSubLocationDropdownOpen ||
            getSelectedItemsCount('subLocation').length > 0
              ? 'border: 1px solid #6574C4; background: #F8F9FF;'
              : 'border: 1px solid #DDE1E6;'
          "
        >
          Sub Locations
          <span
            class="selected-count-badge"
            *ngIf="getSelectedItemsCount('subLocation').length > 0"
          >
            {{ getDisplayText("subLocation") }}
          </span>
          <span
            ><img
              src="/assets/images/down-arrow 1.svg"
              height="16px"
              width="16px"
          /></span>
        </button>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isSubLocationDropdownOpen">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>
          <input
            type="text"
            placeholder="Search sub locations..."
            [(ngModel)]="subLocationSearchText"
            (input)="filterSubLocations()"
            class="search-input"
          />
        </div>

        <div class="mcd-dropdown-options">
          <div
            class="dropdown-option-item"
            *ngFor="let item of filteredSubLocations"
          >
            <mat-checkbox
              [checked]="setCheckedStateForCheckBoxes(5, item.id)"
              (change)="addFilter($event, item.id, 5, item.name, 'subLocation')"
              (click)="$event.stopPropagation()"
            >
              {{ item.name }}
            </mat-checkbox>
          </div>
          <div class="no-results" *ngIf="filteredSubLocations.length === 0">
            No sub locations found
          </div>
        </div>

        <div class="mcd-dropdown-actions">
          <button mat-button class="apply-btn" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Equipment Type Dropdown (Conditional) -->


  <div style="display: inline-block" *ngIf="userRole == 1 || userRole == 4">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header">
        <div class="dropdown-trigger-btn" role="button" tabindex="0" (click)="toggleDropdown('country')" [style]="
            shouldShowCountryFilterHighlight()
              ? 'border: 1px solid #6574C4; background: #F8F9FF;'
              : 'border: 1px solid #DDE1E6;'
          ">
          <span class="trigger-label">Country</span>
          <span class="selected-count-badge">
            {{ countryDisplayText() }}
          </span>
          <button type="button" class="remove-button" *ngIf="showFilterClearButton('country')"
            (click)="removeSelected('country', $event)" aria-label="Clear country filter">
            <img src="/assets/images/s-remove 1.svg" alt="" />
          </button>
          <span class="trigger-chevron"><img src="/assets/images/down-arrow 1.svg" height="16px" width="16px"
              [style.transform]="isCountryDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'"
              [style.transition]="'transform 0.3s ease'" /></span>
        </div>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isCountryDropdownOpen">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>
          <input type="text" placeholder="Search" [(ngModel)]="countrySearchText" (input)="filterCountries()"
            class="search-input" />
        </div>

        <div class="country-dropdown-options">
          <ng-container *ngFor="let item of filteredCountries; let i = index">
            <div class="country-dropdown-option-item" [class.selected]="selectedCountryId === item.id"
              (click)="onCountrySelect(item)">
              {{ item.name }}
            </div>
            <div class="filter-selected-divider" *ngIf="showCountryFilterDivider(filteredCountries, i)"></div>
          </ng-container>
          <div class="no-results" *ngIf="filteredCountries.length === 0">
            No countries found
          </div>
        </div>

        <!-- <div class="mcd-dropdown-actions">
        <button mat-button class="apply-btn" (click)="applyFilters()">
          Apply
        </button>
      </div> -->
      </div>
    </div>
  </div>

  <!-- Spacer -->
  <div style="flex: 1"></div>

  <!-- Optional: Extract Button -->
  <div>
    <button class="extract-button" (click)="openExportModal()">
      <img src="/assets/images/export 1.svg" style="margin-right: 5px" />Export
    </button>
  </div>
</div>


<div *ngIf="isExportModalOpen" class="modal-overlay" (click)="closeExportModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2>Export Standards</h2>
      <button class="close-btn" (click)="closeExportModal()">×</button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <!-- Equipment Type Dropdown -->
      <div class="filter-group">
        <label class="filter-label">Equipment Type</label>
        <div class="export-modal-filter-dropdown-wrapper" [style.z-index]="isExportEquipmentTypeDropdownOpen ? 30 : 1">
          <div class="export-modal-dropdown-header" (click)="toggleExportDropdown('equipment')">
            <button class="export-modal-dropdown-trigger-btn buttonArrow" [style]="
                isExportEquipmentTypeDropdownOpen ||
                getExportSelectedItemsCount('equipment').length > 0
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              " style="display: flex; justify-content: space-between; width: 100%">
              <span class="export-modal-selected-count-badge"
                *ngIf="getExportSelectedItemsCount('equipment').length > 0">
                {{ getExportDisplayText("equipment") }}
              </span>
              <span *ngIf="getExportSelectedItemsCount('equipment').length == 0">
                All
              </span>
              <span>
                <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px" [style.transform]="
                    isExportEquipmentTypeDropdownOpen
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  " [style.transition]="'transform 0.3s ease'" />
              </span>
            </button>
          </div>

          <!-- Equipment Type Options - INSIDE the wrapper with absolute positioning -->
          <div class="export-modal-dropdown-content" *ngIf="isExportEquipmentTypeDropdownOpen">
            <div class="export-modal-dropdown-options">
              <ng-container *ngFor="let item of filteredequipmentTypes; let i = index">
                <div class="export-modal-dropdown-option-item">
                  <mat-checkbox [checked]="setExportCheckedStateForCheckBoxes(4, item.id)" (change)="
                      addExportFilter(
                        $event,
                        item.id,
                        4,
                        item.name,
                        'equipment'
                      )
                    " (click)="$event.stopPropagation()">
                    {{item.name}}
                  </mat-checkbox>
                </div>
                <div class="filter-selected-divider" *ngIf="showExportFilterDivider(filteredequipmentTypes, i, 4)">
                </div>
              </ng-container>
              <div class="export-modal-no-results" *ngIf="filteredequipmentTypes.length === 0">
                No equipment types found
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Location Dropdown -->
      <div class="filter-group">
        <label class="filter-label">Location</label>
        <div class="export-modal-filter-dropdown-wrapper" [style.z-index]="isExportLocationDropdownOpen ? 30 : 1">
          <div class="export-modal-dropdown-header" (click)="toggleExportDropdown('location')">
            <button class="export-modal-dropdown-trigger-btn buttonArrow" [style]="
                isExportLocationDropdownOpen ||
                getExportSelectedItemsCount('location').length > 0
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              " style="display: flex; justify-content: space-between; width: 100%">
              <span class="export-modal-selected-count-badge"
                *ngIf="getExportSelectedItemsCount('location').length > 0">
                {{ getExportDisplayText("location") }}
              </span>
              <span *ngIf="getExportSelectedItemsCount('location').length == 0">
                All
              </span>
              <span>
                <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px" [style.transform]="
                    isExportLocationDropdownOpen
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  " [style.transition]="'transform 0.3s ease'" />
              </span>
            </button>
          </div>

          <!-- Location Options - INSIDE the wrapper with absolute positioning -->
          <div class="export-modal-dropdown-content" *ngIf="isExportLocationDropdownOpen">
            <div class="export-modal-dropdown-options">
              <ng-container *ngFor="let item of filteredLocations; let i = index">
                <div class="export-modal-dropdown-option-item">
                  <mat-checkbox [checked]="setExportCheckedStateForCheckBoxes(1, item.id)" (change)="
                      addExportFilter($event, item.id, 1, item.name, 'location')
                    " (click)="$event.stopPropagation()">
                    {{ item.name }}
                  </mat-checkbox>
                </div>
                <div class="filter-selected-divider" *ngIf="showExportFilterDivider(filteredLocations, i, 1)"></div>
              </ng-container>
              <div class="export-modal-no-results" *ngIf="filteredLocations.length === 0">
                No locations found
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Country Dropdfoen -->
      <div class="filter-group" *ngIf="userRole == 1 || userRole == 4">
        <label class="filter-label">Country</label>
        <div class="export-modal-filter-dropdown-wrapper" [style.z-index]="isExportCountryDropdownOpen ? 30 : 1">
          <div class="export-modal-dropdown-header" (click)="toggleExportDropdown('country')">
            <button class="export-modal-dropdown-trigger-btn buttonArrow" [style]="
                isExportCountryDropdownOpen 
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              " style="display: flex; justify-content: space-between; width: 100%">
              <span class="export-modal-selected-count-badge" *ngIf="ExportselectedCountryIds.length > 0">
                {{ getCountryDisplayText() }}
              </span>
              <span *ngIf="ExportselectedCountryIds.length ==  0">
                All
              </span>
              <span>
                <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px" [style.transform]="
                    isExportCountryDropdownOpen
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  " [style.transition]="'transform 0.3s ease'" />
              </span>
            </button>
          </div>

          <!-- Location Options - INSIDE the wrapper with absolute positioning -->
          <div class="export-modal-dropdown-content" *ngIf="isExportCountryDropdownOpen">
            <div class="export-modal-dropdown-options">
              <ng-container *ngFor="let item of filteredCountries | slice:1; let i = index">
                <div class="export-modal-dropdown-option-item">
                  <mat-checkbox [checked]="isCountrySelected(item.id)"
                    (change)="onCountrySelectionChange($event, item.id)" (click)="$event.stopPropagation()">
                    {{ item.name }}
                  </mat-checkbox>
                </div>
                <div class="filter-selected-divider" *ngIf="
                    showExportCountryFilterDivider(
                      filteredCountries | slice: 1,
                      i
                    )
                  "></div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal Footer with Buttons -->
    <div class="export-modal-footer">
      <button class="export-modal-cancel-btn" (click)="closeExportModal()">
        Cancel
      </button>
      <button class="export-modal-export-btn" (click)="applyExportFilters()">
        <img src="/assets/images/export-black.svg" style="
            margin-bottom: 2px;
            margin-right: 4px;
            height: 12px;
            width: 12px;
          " />Export
      </button>
    </div>
  </div>
</div>